'use client';

// Bloc widget "Colonnes" : conteneur multi-colonnes pour pages CMS.
// Rend N cellules côte à côte (1 à 4), chacune avec son propre type de bloc.
// Réglages : largeur container (small/normal/full), gap entre colonnes,
// padding haut/bas section.
import BlockRenderer from './BlockRenderer';

const WIDTH_MAP = {
  small:  '760px',
  normal: '1280px',
  full:   '100%',
};

export default function ColumnsBlock({ config }) {
  if (!config) return null;
  const count = Math.max(1, Math.min(4, parseInt(config.count, 10) || 2));
  const cells = (Array.isArray(config.cells) ? config.cells : []).slice(0, count);
  const gap = Math.max(0, parseInt(config.gap, 10) || 0);
  const py = Math.max(0, parseInt(config.padding_y, 10) || 0);
  const maxW = WIDTH_MAP[config.width || 'normal'] || WIDTH_MAP.normal;
  const isFull = (config.width || 'normal') === 'full';

  return (
    <section style={{
      padding: `${py}px 0`,
      background: '#fff',
    }}>
      <div style={{
        maxWidth: maxW,
        margin: '0 auto',
        padding: isFull ? 0 : '0 24px',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
          gap: `${gap}px`,
        }} className="columns-block-grid">
          {cells.map((cell, idx) => (
            <div key={idx} style={{ minWidth: 0 }}>
              {/* Délègue le rendu au router central, comme un bloc top-level.
                  Pas d'imbrication récursive : on a interdit columns dans columns
                  côté admin (ALLOWED_TYPES de ColumnsEditor). */}
              <BlockRenderer block={{ id: `col-${idx}`, type: cell.type, config: cell.config || {} }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
